/* eslint-disable react/no-danger */
/* eslint-disable react/jsx-props-no-spreading */
const Dangerous = (props) => {
  const { html: __html = '', as: As = 'script', ...rest } = props;
  return <As dangerouslySetInnerHTML={{ __html }} {...rest} />;
};

export default Dangerous;
